import styles from './styles.module.scss';
import { getCropName } from '../../utils/crops';

const CropName = ({ t, cropId, crops, size = '' }) => {
  return (
    <div className={styles.cropName}>
      {crops && (
        <div
          className={`${styles.cropNameIcon} ${size === 'small' ? styles.cropNameIconSmall : ''}`}
          style={{
            backgroundColor: crops.filter((c) => c.id === cropId)
              ? crops.filter((c) => c.id === cropId)[0]?.color
              : 'var(--neutral-7)',
          }}
        ></div>
      )}
      {cropId ? getCropName({t, id: cropId}) : t('empty.noData')}
    </div>
  );
};

export default CropName;
